import { useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { IconButtonV2, LoaderSkeleton, OverlayPopover, Popover } from '@utilities';
import { InfoCircleIcon } from '@utilities/icons';

import { getCapacityDateText } from '../../utilities/helpers';

import styles from './_index.module.scss';

const NexaCapacityTracker = ({
  currentEndDatetime,
  nextStartDatetime,
  placement,
  tokensPercentRemaining,
}) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const triggerRef = useRef(null);
  const dateText = useMemo(
    () => getCapacityDateText({ currentEndDatetime, nextStartDatetime }),
    [currentEndDatetime, nextStartDatetime]
  );

  return (
    <div className={styles['capacity-tracker']}>
      <div className={styles['capacity-summary']}>
        <IconButtonV2
          aria-expanded={isPopoverOpen}
          aria-label="Open Nexa capacity details"
          icon={<InfoCircleIcon />}
          onClick={() => setIsPopoverOpen((isOpen) => !isOpen)}
          ref={triggerRef}
          size="small"
          tooltip="More details"
          tooltipProps={{ placement: 'top' }}
          variant="subtle"
        />
        <span>Nexa capacity</span>
      </div>

      <OverlayPopover
        className={styles['capacity-popover']}
        hasArrow
        header="REMAINING CAPACITY"
        isActive={isPopoverOpen}
        onHide={() => setIsPopoverOpen(false)}
        placement={placement}
        target={triggerRef.current}
      >
        <Popover.Body>
          {tokensPercentRemaining === undefined ? (
            <LoaderSkeleton height={20} width={240}>
              <rect height="20" rx="4" ry="4" width="240" x="0" y="0" />
            </LoaderSkeleton>
          ) : (
            <>
              <dl className={styles['capacity-details']}>
                <div>
                  <dt>Organization</dt>
                  <dd>{tokensPercentRemaining}%</dd>
                </div>
              </dl>
              {dateText && <p className={styles['capacity-date']}>{dateText}</p>}
            </>
          )}
        </Popover.Body>
      </OverlayPopover>
    </div>
  );
};

NexaCapacityTracker.propTypes = {
  currentEndDatetime: PropTypes.string,
  nextStartDatetime: PropTypes.string,
  placement: PropTypes.oneOf(['bottom', 'top']),
  tokensPercentRemaining: PropTypes.number,
};

NexaCapacityTracker.defaultProps = {
  placement: 'top',
};

export default NexaCapacityTracker;
